<template>
  <div id="app">
    <div class="app-container" :class="{ 'no-tabbar': !showTabbar }">
      <router-view />
    </div>
    <!-- 底部导航栏 -->
    <van-tabbar v-if="showTabbar" v-model="active" active-color="#24b1ac" inactive-color="#7d7e80" route>
      <van-tabbar-item icon="home-o" to="/home">评估</van-tabbar-item>
      <van-tabbar-item icon="chart-trending-o" to="/report">报告</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    // 需要隐藏底部导航栏的路由列表
    showTabbar() {
      const hideTabbarRoutes = [
        '/questionnaire',
        '/affirm',
        '/queryReport',
        '/reportDetail',
        '/artcileList',
        '/artciledetail',
        '/register',
        '/realName',
        '/myselfmess',
        '/nutritionReport',
        '/RedirectGuard',
        '/401'
      ];
      return !hideTabbarRoutes.includes(this.$route.path);
    }
  },
  created() {
    const url = new URL(window.location.href.replace("#/", ""));
    const token = url.searchParams.get("token");
    if (token) {
      localStorage.setItem("token", token);
    }
    // 根据当前路由设置激活的 tab
    this.setActiveTab();
    // alert("token: " + token);
  },
  watch: {
    $route() {
      this.setActiveTab();
    },
  },
  methods: {
    setActiveTab() {
      const path = this.$route.path;
      if (path === "/home") {
        this.active = 0;
      } else if (path === "/report") {
        this.active = 1;
      }
    },
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
}

.app-container {
  height: 100%;
  padding-bottom: 50px; /* 为底部导航栏留出空间 */
  overflow-y: auto;
}

/* 当没有底部导航栏时，不需要底部留白 */
.app-container.no-tabbar {
  padding-bottom: 0;
}

@media only screen and (min-width: 340px) {
  html {
    font-size: 14px;
  }
}

@media only screen and (min-width: 401px) {
  html {
    font-size: 16px;
  }
}

@media only screen and (min-width: 428px) {
  html {
    font-size: 20px;
  }
}

@media only screen and (min-width: 481px) {
  html {
    font-size: 22px;
  }
}

@media only screen and (min-width: 569px) {
  html {
    font-size: 24px;
  }
}

@media only screen and (min-width: 641px) {
  html {
    font-size: 26px;
  }
}
</style>
